import React, { useEffect, useState } from "react";
import "./Countdown.scss";

interface CountdownProps {
  targetDate: string | Date;
}

interface TimeLeft {
  total: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const getTimeRemaining = (target: string | Date): TimeLeft => {
  const total = Date.parse(target.toString()) - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days: Math.max(0, days),
    hours: Math.max(0, hours),
    minutes: Math.max(0, minutes),
    seconds: Math.max(0, seconds),
  };
};

const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(getTimeRemaining(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.total <= 0) {
    return <div className="countdown">¡El día ha llegado!</div>;
  }

  return (
    <div className="countdown">
      <div className="countdown__segment">
        <span className="countdown__value">{timeLeft.days}</span>
        <span className="countdown__label">Días</span>
      </div>
      <div className="countdown__segment">
        <span className="countdown__value">{timeLeft.hours}</span>
        <span className="countdown__label">Horas</span>
      </div>
      <div className="countdown__segment">
        <span className="countdown__value">{timeLeft.minutes}</span>
        <span className="countdown__label">Minutos</span>
      </div>
      <div className="countdown__segment">
        <span className="countdown__value">{timeLeft.seconds}</span>
        <span className="countdown__label">Segundos</span>
      </div>
    </div>
  );
};

export default Countdown;
